export default function BookingHistorySkeleton() {
  return (
    <div className="space-y-4">
      {[1, 2, 3, 4].map((s) => (
        <div
          key={s}
          className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm flex flex-col md:flex-row gap-4 animate-pulse"
        >
          <div className="flex-1 space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gray-100" />
                <div className="space-y-1.5">
                  <div className="h-4 bg-gray-100 rounded w-32" />
                  <div className="h-3 bg-gray-100 rounded w-24" />
                </div>
              </div>
              <div className="h-6 w-20 bg-gray-100 rounded-full" />
            </div>
            
            <div className="flex items-center gap-4 pt-2">
              <div className="h-3 bg-gray-100 rounded w-24" />
              <div className="h-3 bg-gray-100 rounded w-32" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}